import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function SettingsScreen() {
    return html`
        <div id="settings-screen" class="screen" style="display: none;">
            <h2>Account Settings</h2>
            <div class="settings-form">
                <div class="form-group">
                    <label for="settings-display-name">Display Name</label>
                    <div class="input-with-button">
                        <input type="text" id="settings-display-name" />
                        <button id="save-display-name-btn" class="btn btn-primary">Save</button>
                    </div>
                </div>
                <div class="form-group">
                    <label for="settings-email">Email</label>
                    <input type="email" id="settings-email" readonly disabled />
                </div>
                <div class="form-group checkbox-group">
                    <label>
                        <input type="checkbox" id="settings-notifications" />
                        Enable Notifications
                    </label>
                </div>
            </div>
        </div>
    `;
}
